import React, { SelectHTMLAttributes } from "react";

interface SelectSituacaoProps extends SelectHTMLAttributes<HTMLSelectElement> {
  isCadastro?: boolean
}

export const SelectSituacao = ({ isCadastro, ...rest }: SelectSituacaoProps) => {
  return (
    <div className="my-2 flex h-8 w-full items-center justify-between gap-4">
      <p className="w-2/6 font-medium text-gray-700">Situação: </p>
      <select className="h-full w-full bg-gray-200 px-1 py-2" name="situacaotelefone" {...rest} >
        {!isCadastro && <option value="Valido">Valido</option>}
        {!isCadastro && <option value="Invalido">Invalido</option>}
        <option value="Contactado">Contactado</option>
        {!isCadastro && <option value="Invalido Triagem">Invalido Triagem</option>}
        {!isCadastro && <option value="Bloqueado">Bloqueado</option>}
        {!isCadastro && <option value="Invalido URA">Invalido URA</option>}
        {!isCadastro && <option value="Invalido Callcenter">Invalido Callcenter</option>}
        {!isCadastro && <option value="Blacklist">Blacklist</option>}
      </select>
    </div>
  )
}